"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaterange = void 0;
const date_fns_1 = require("date-fns");
const react_1 = __importDefault(require("react"));
const constants_1 = require("../utils/constants");
const functions_1 = require("../utils/functions");
const hooks_1 = require("../utils/hooks");
const useDaterange = (propValue) => {
    const [calendarValue, setCalendarValue] = react_1.default.useState(propValue);
    const [pickerValue, setPickerValue] = react_1.default.useState(propValue
        ? {
            start: propValue.start && (0, date_fns_1.format)(propValue.start, constants_1.DATEPICKER_FORMAT),
            end: propValue.end && (0, date_fns_1.format)(propValue.end, constants_1.DATEPICKER_FORMAT),
        }
        : {});
    const [show, setShow] = react_1.default.useState(false);
    const dropRef = (0, hooks_1.useClickOutside)(show, () => setShow(false));
    const onDaterangeChange = react_1.default.useCallback((text, order) => {
        const parsedValue = (0, functions_1.parseValidStringToDate)(text);
        if (parsedValue) {
            setCalendarValue(Object.assign(Object.assign({}, calendarValue), { [order]: parsedValue }));
        }
        setPickerValue(Object.assign(Object.assign({}, pickerValue), { [order]: text }));
    }, [calendarValue]);
    const handleValueUpdate = react_1.default.useCallback((newValue) => {
        setCalendarValue(newValue);
        setPickerValue({
            start: newValue.start && (0, date_fns_1.format)(newValue.start, constants_1.DATEPICKER_FORMAT),
            end: newValue.end && (0, date_fns_1.format)(newValue.end, constants_1.DATEPICKER_FORMAT),
        });
    }, [calendarValue, pickerValue]);
    return {
        pickerValue,
        calendarValue,
        show,
        dropRef,
        setShow,
        onDaterangeChange,
        handleValueUpdate,
    };
};
exports.useDaterange = useDaterange;
//# sourceMappingURL=useDaterange.js.map